export default "__VITE_ASSET__f6bc0148__"